import React from 'react';
import { ExternalLink } from './ExternalLink';

interface BaseButtonProps {
  variant?: 'primary' | 'outline';
  className?: string;
}

interface ButtonAsButtonProps extends BaseButtonProps, React.ButtonHTMLAttributes<HTMLButtonElement> {
  as?: 'button';
}

interface ButtonAsAnchorProps extends BaseButtonProps, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  as: 'a';
}

type ButtonProps = ButtonAsButtonProps | ButtonAsAnchorProps;

export function Button({ 
  variant = 'primary', 
  className = '', 
  as = 'button',
  ...props 
}: ButtonProps) {
  const baseStyles = 'px-8 py-3 rounded-lg text-lg font-medium transition-colors w-full sm:w-auto flex items-center justify-center text-center';
  const variants = {
    primary: 'bg-[#f8cb08] hover:brightness-110 text-black',
    outline: 'border border-gray-500 hover:border-white'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;

  if (as === 'a') {
    return (
      <ExternalLink 
        className={combinedClassName}
        {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {props.children}
      </ExternalLink>
    );
  }

  return (
    <button 
      className={combinedClassName}
      {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {props.children}
    </button>
  );
}